import { Component } from 'react'
import './index.css'
import arch_des_zh from './images/arch_des_zh.png'
import arch_des_en from './images/arch_des_en.png'

import left_highArch from './images/left_highArch.png'
import left_slightly_highArch from './images/left_slightly_highArch.png'
import left_mildArch from './images/left_mildArch.png'
import left_slightly_flatFoot from './images/left_slightly_flatFoot.png'
import left_flatFoot from './images/left_flatFoot.png'
import right_highArch from './images/right_highArch.png'
import right_slightly_highArch from './images/right_slightly_highArch.png'
import right_mildArch from './images/right_mildArch.png'
import right_slightly_flatFoot from './images/right_slightly_flatFoot.png'
import right_flatFoot from './images/right_flatFoot.png'
import { WithTranslationProps, withTranslation } from 'react-i18next'
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"


interface StateProps {
    data: any,
    staticReport: any
}

class Index extends Component<StateProps & WithTranslationProps> {

    state = {
        imgDataLeft: '',
        imgDataRight: '',
        standRange: {
            min: 0,
            max: 0
        }
    }

    initData = () => {
        let data = {
            left: {
                value: '',
                level: '',
                archImg: left_mildArch,
                rainBowImg: '',
                dot: 0,
            },
            right: {
                value: '',
                level: '',
                archImg: right_mildArch,
                rainBowImg: '',
                dot: 0,
            }
        }
        let report = this.props.data;
        let staticReport = this.props.staticReport;
        if (report.left && report.right) {
            const reference_ranges = report.left.referenceRanges
            const stands: number[] = Array.from(new Set(Object.values(reference_ranges).flatMap((range: any) => [range.min, range.max]))).sort((a, b) => a - b);

            const levelLeft = this.levelFun(report.left.value, stands);
            data.left.value = (report.left.value * 100).toFixed(2);
            data.left.level = this.returnLevel(levelLeft);
            data.left.archImg = this.returnImgLeft(levelLeft);
            data.left.rainBowImg = staticReport.left.heelPressureMapUrl;
            data.left.dot = this.returnPoint(levelLeft);

            const levelRight = this.levelFun(report.right.value, stands);
            data.right.value = (report.right.value * 100).toFixed(2);
            data.right.level = this.returnLevel(levelRight);
            data.right.archImg = this.returnImgRight(levelRight);
            data.right.rainBowImg = staticReport.left.heelPressureMapUrl;
            data.right.dot = this.returnPoint(levelRight);

            if (data.right.dot === data.left.dot) {
                if(report.left.value < report.right.value) {
                    data.left.dot -= 2;
                    data.right.dot += 4;
                }
                else {
                    data.left.dot += 4;
                    data.right.dot -= 2;
                }
               
            }
        }
        return data;
    }

    levelFun = (value: number, stand: number[]) => {
        if (value >= stand[4]) return "FLAT";
        if (value >= stand[3]) return "FLAT_MILD";
        if (value >= stand[2]) return "NORMAL";
        if (value >= stand[1]) return "HIGH_MILD";
        if (value >= stand[0]) return "HIGH";
        return "NORMAL";
    };

    returnLevel = (key) => {
        const i18n = this.props.i18n;
        if (!i18n) {
            return '';
        }
        switch (key) {
            case 'HIGH': return i18n.t('highArch');
            case 'HIGH_MILD': return i18n.t('slightlyHighArch');
            case 'NORMAL': return i18n.t('middleArch');
            case 'FLAT_MILD': return i18n.t('slightlyFlatfoot');
            case 'FLAT': return i18n.t('flatfoot');
            default: return '';
        }
    }


    returnImgLeft = (key) => {
        switch (key) {
            case 'HIGH': return left_highArch;
            case 'HIGH_MILD': return left_slightly_highArch;
            case 'NORMAL': return left_mildArch;
            case 'FLAT_MILD': return left_slightly_flatFoot;
            case 'FLAT': return left_flatFoot;
            default: return left_mildArch;
        }
    }

    returnImgRight = (key) => {
        switch (key) {
            case 'HIGH': return right_highArch;
            case 'HIGH_MILD': return right_slightly_highArch;
            case 'NORMAL': return right_mildArch;
            case 'FLAT_MILD': return right_slightly_flatFoot;
            case 'FLAT': return right_flatFoot;
            default: return right_mildArch;
        }
    }

    returnPoint = (key) => {
        switch (key) {
            case 'HIGH': return 9;
            case 'HIGH_MILD': return 27;
            case 'NORMAL': return 45;
            case 'FLAT_MILD': return 65;
            case 'FLAT': return 84;
            default: return 0;
        }
    }

    returnImgSrc = () => {
        const i18n = this.props.i18n;
        const img_zh = {
            des: arch_des_zh,
        }
        const img_en = {
            des: arch_des_en,
        }
        if (!i18n) {
            return img_zh;
        }
        else {
            switch (i18n.language) {
                case 'zh': return img_zh;
                case 'en': return img_en;
                default: return img_zh;
            }
        }
    }

    componentDidMount() {
        this.getArchLevelStand();
        this.drawRainbowArch("left");
        this.drawRainbowArch("right");
    }

    getArchLevelStand = () => {
        const report = this.props.data;
        const reference_ranges = report.left.referenceRanges.normal
        this.setState({ standRange: reference_ranges });
    }

    drawRainbowArch = (type) => {
        let canvas = document.createElement('canvas') as any;
        canvas.width = '280';
        canvas.height = '246';
        let ctx = canvas.getContext('2d');
        const staticReport = this.props.staticReport;
        let yA = staticReport[type].toesForefootHorizontalLine;
        let yB = staticReport[type].forefootMidfootHorizontalLine;
        let yC = staticReport[type].midfootHeelHorizontalLine;
        let url = staticReport[type].croppedThumbnailUrl;
        if (!url) return;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        let img = new Image();
        img.crossOrigin = "anonymous";
        img.src = url;
        const that = this;
        img.onload = function () {

            let startX = 0;
            let width = canvasHeight / img.height * img.width;
            let px = (canvasWidth - width);
            yA = yA / img.height * canvasHeight;
            yB = yB / img.height * canvasHeight;
            yC = yC / img.height * canvasHeight;

            if(type == "left") {
                startX = px;
            }
            
            ctx.drawImage(img, startX, 0, width, canvasHeight);
            

            ctx.globalAlpha = 0.2;

            ctx.fillStyle = '#EF4646';
            ctx.fillRect(startX, yA, width, yB - 2 - yA);
            ctx.fill();

            ctx.fillStyle = '#00C1D8';
            ctx.fillRect(startX, yB, width, yC - 2 - yB);
            ctx.fill();

            ctx.fillStyle = '#619CFF';
            ctx.fillRect(startX, yC, width, canvasHeight - yC);
            ctx.fill();

            // 画 A 线性背景
            let grd = ctx.createLinearGradient(0, 0, 0, 136);
            grd.addColorStop(0, "#FF9D9D");
            grd.addColorStop(1, "#FE6666");

            let roundWidth = 80;
            let roundHeight = 26;

            let Ax = width + (px - roundWidth) / 2;
            let Ay = yA + (yB - 2 - yA - roundHeight) / 2;
            if(type == "left") {
                Ax = (px - roundWidth) / 2
            }
            ctx.globalAlpha = 1;
            ctx.fillStyle = grd;
            that.drawRoundRect(ctx, Ax, Ay, roundWidth, roundHeight, roundHeight / 2)
            ctx.fill();
            ctx.strokeStyle = "#FF9D9D";
            ctx.stroke();


            // 画 B 线性背景
            grd = ctx.createLinearGradient(0, 0, 0, 136 + roundHeight * 2);
            grd.addColorStop(0, "#4EEDF6");
            grd.addColorStop(0.5, "#00C1CD");
            grd.addColorStop(1, "#45E8F2");

            let By = yB + (yC - 2 - yB - roundHeight) / 2;

            ctx.fillStyle = grd;
            that.drawRoundRect(ctx, Ax, By, roundWidth, roundHeight, roundHeight / 2)
            ctx.fill();
            ctx.strokeStyle = "#45E8F2";
            ctx.stroke();

            // 画 C 线性背景
            grd = ctx.createLinearGradient(0, 0, 0, 400);
            grd.addColorStop(0, "#8FBBF8");
            grd.addColorStop(1, "#4F89EA");

            let Cy = yC + (canvasHeight - yC - roundHeight) / 2;

            ctx.fillStyle = grd;
            that.drawRoundRect(ctx, Ax, Cy, roundWidth, roundHeight, roundHeight / 2)
            ctx.fill();
            ctx.strokeStyle = "#4F89EA";
            ctx.stroke();

            let valueA = staticReport[type].archForefootValue || 0;
            let valueB = staticReport[type].arch.value || 0;
            let valueC =  staticReport[type].archHindfootValue || 0;

            ctx.font = "14px sans-serif";
            ctx.fillStyle = "#FFFFFF";
            ctx.fillText(`A: ${(valueA * 100).toFixed(2)}%`, Ax + 10, Ay + 17);
            ctx.fillText(`B: ${(valueB * 100).toFixed(2)}%`, Ax + 10, By + 17);
            ctx.fillText(`C: ${(valueC * 100).toFixed(2)}%`, Ax + 10, Cy + 17);

            let tempSrc = canvas.toDataURL('imgae/png');
            if(type == "right") {
                that.setState({
                    imgDataRight: tempSrc,
                })
            }
            else {
                that.setState({
                    imgDataLeft: tempSrc,
                })
            }
            
        }
    }

    drawRoundRect = (cxt, x, y, width, height, radius) => {
        cxt.beginPath();
        cxt.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2);
        cxt.lineTo(width - radius + x, y);
        cxt.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2);
        cxt.lineTo(width + x, height + y - radius);
        cxt.arc(width - radius + x, height - radius + y, radius, 0, Math.PI * 1 / 2);
        cxt.lineTo(radius + x, height + y);
        cxt.arc(radius + x, height - radius + y, radius, Math.PI * 1 / 2, Math.PI);
        cxt.closePath();
    }


    render() {

        let data = this.initData();
        if (!data.left.level || !data.right.level) {
            return null;
        }
        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }
        let imgSrc = this.returnImgSrc();

        return (
            <div className="standing-archAnaly">
                <p className="reportCom-container-title">
                    {/* <img src={icon_reportDetail_head} alt="icon head" /> */}
                    <span>{i18n.t('archAnaly')}</span>
                </p>
                <ul>
                    <li className="rainbow">
                        <img src={this.state.imgDataLeft} />
                    </li>
                    <li className="rainbow">
                        <img src={this.state.imgDataRight} />
                    </li>
                    <li>
                        <div className="tableData">
                            <p>{i18n.t("footArchAI")}</p>
                            <table>
                                <tbody>
                                <tr>
                                    <td>{i18n.t("leftFoot")}</td>
                                    <td>{i18n.t("rightFoot")}</td>
                                </tr>
                                <tr>
                                    <td style={{ color: "#01c1ce"}}>{data.left.value}%</td>
                                    <td style={{ color: "#01c1ce"}}>{data.right.value}%</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                    <img style={{width: "34px", margin: "20px 16px 10px"}} src={right_highArch} alt="" />
                                    <img src={right_slightly_highArch} alt="" />
                                    <img src={right_mildArch} alt="" />
                                    <img src={right_slightly_flatFoot} alt="" />
                                    <img src={right_flatFoot} alt="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>{i18n.t("standardRange")}</td>
                                    <td>{Math.floor(this.state.standRange.min * 100)}% - {Math.floor(this.state.standRange.max * 100)}%</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </li>
                </ul>
                <p className="archExplain">
                    {i18n.t('archExplainAI', {min: Math.floor(this.state.standRange.min * 100), max: Math.floor(this.state.standRange.max * 100)})}
                </p>
            </div>
        )
    }
}

export default withTranslation()(Index)